import { atom } from 'jotai';
import callApi from 'lib/callApi';
import { companyIdAtom } from 'views/state';

import { KPIDashboardData } from './types';

export const kpiRefreshAtom = atom('');

const metricLabelOverrides: Record<string, string> = {
  ca_new_vulnerabilities: 'New vulnerabilities',
  ca_fixed_vulnerabilities: 'Fixed vulnerabilities',
  ca_avg_remediation_days: 'Average days to closure',
  wa_avg_remediation_days: 'Average days to closure',
  endpoint_avg_remediation_days: 'Average days to closure',
  sast_avg_remediation_days: 'Average days to closure',
  pc_avg_time_to_pass_days: 'Average days to closure',
  wa_high_severity_findings: 'High-severity vulnerabilities',
  endpoint_high_severity_findings: 'High-severity vulnerabilities',
  sast_high_severity_findings: 'High-severity vulnerabilities',
};

export const kpiDashboardDataAtom = atom(async (get) => {
  const companyId = get(companyIdAtom);
  const _refresh = get(kpiRefreshAtom);

  if (!companyId || companyId <= 0) return undefined;

  try {
    // A KPI-specific cancellation scope keeps tenant switches and manual
    // refreshes from sharing request state with the other dashboard tabs.
    // The dashboard only needs current and previous values. History is loaded
    // for the selected KPI section on its detail page to keep initial load small.
    const response = await callApi(
      'kpi/dashboard/',
      'GET',
      { company_id: companyId },
      null,
      null,
      'kpi/dashboard/:kpi-dashboard',
    );
    const dashboardData = response?.data as KPIDashboardData | undefined;
    if (!dashboardData) return undefined;

    return {
      ...dashboardData,
      sections: dashboardData.sections.map((section) => ({
        ...section,
        metrics: section.metrics.map((metric) => ({
          ...metric,
          // Normalize Cloud Agent wording once so tiles, details, charts,
          // tooltips, manual forms, and exports all display the same KPI name.
          label: metricLabelOverrides[metric.key] || metric.label,
        })),
      })),
    };
  } catch (_error) {
    return undefined;
  }
});
